(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/components/result-sportkryss.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/components/result-sportkryss.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const WinDiv = svs.components.tipsen.winDiv.WinDiv;
const format = svs.utils.format;
const SportkryssNumbers = svs.components.tipsen.SportkryssMybetsResult.SportkryssNumbers;
const _svs$components$tipse = svs.components.tipsen.routeResult,
  useSelectedSportkryss = _svs$components$tipse.useSelectedSportkryss,
  ResultSportkryssFallback = _svs$components$tipse.ResultSportkryssFallback;
const useBranding = svs.components.tipsen.hooks.useBranding;
const TableHolder = svs.components.tipsen.routeResult.TableHolder;
const Paper = svs.ui.ReactPaper;
const ResultSportkryss = _ref => {
  var _sportkryssetData$dat, _sportkryssetData$dat2;
  let currentDateDraw = _ref.currentDateDraw,
    month = _ref.month,
    year = _ref.year,
    sportkryssFactors = _ref.sportkryssFactors;
  const className = 'pg_windiv--result pg_windiv--result-sportkryss';
  const _useSelectedSportkrys = useSelectedSportkryss(year, month, currentDateDraw, sportkryssFactors),
    _useSelectedSportkrys2 = _slicedToArray(_useSelectedSportkrys, 2),
    sportkryssetData = _useSelectedSportkrys2[0],
    loadingSportkrysset = _useSelectedSportkrys2[1];
  const _useBranding = useBranding(),
    _useBranding2 = _slicedToArray(_useBranding, 1),
    productBranding = _useBranding2[0];
  if (loadingSportkrysset) {
    return React.createElement(ResultSportkryssFallback, null);
  }
  if (!sportkryssetData || Object.keys(sportkryssetData) === 0) {
    return null;
  }
  return React.createElement(TableHolder, {
    label: "Sportkryss"
  }, React.createElement(Paper, {
    branding: "sport"
  }, React.createElement("div", {
    className: "sportkryss-lg-cicle-container pg_sportkryss__result_page"
  }, React.createElement(SportkryssNumbers, {
    branding: productBranding,
    sportkryssetResultData: sportkryssetData === null || sportkryssetData === void 0 || (_sportkryssetData$dat = sportkryssetData.data) === null || _sportkryssetData$dat === void 0 || (_sportkryssetData$dat = _sportkryssetData$dat.result) === null || _sportkryssetData$dat === void 0 || (_sportkryssetData$dat = _sportkryssetData$dat.drawResult) === null || _sportkryssetData$dat === void 0 ? void 0 : _sportkryssetData$dat.numbers
  })), React.createElement(WinDiv, {
    className: className,
    drawWinDivs: sportkryssetData === null || sportkryssetData === void 0 ? void 0 : sportkryssetData.winDivArray,
    isSportkryss: true
  }), React.createElement("p", {
    className: "sportkryss-turnover"
  }, React.createElement("span", null, "Oms\xE4ttning:"), React.createElement("span", {
    className: "turnover-value"
  }, "".concat(format.Currency(parseInt((_sportkryssetData$dat2 = sportkryssetData.data) === null || _sportkryssetData$dat2 === void 0 || (_sportkryssetData$dat2 = _sportkryssetData$dat2.result) === null || _sportkryssetData$dat2 === void 0 ? void 0 : _sportkryssetData$dat2.currentNetSale, 10)), " kr")))));
};
setGlobal('svs.components.tipsen.routeResult.ResultSportkryss', ResultSportkryss);

 })(window);